<template>
  <div :id="id" class="row align-items-center">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmSelect
      :id="`css-${id}`"
      class="col-12 col-md-6"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <LmTextInput
      v-if="validateSuperUser"
      :id="`name-${id}`"
      class="col-12"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmTextInput
      :id="`help-${id}`"
      class="col-12"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />
    <LmCheckbox
      class="col-12 col-md-4"
      labelSingle="Usar menciones"
      v-model="component.componentProps.useMentions"
    />
    <LmCheckbox
      class="col-12 col-md-4"
      labelSingle="Largo fijo"
      v-model="component.componentProps.scrollable"
    />
    <LmCheckbox
      class="col-12 col-md-4"
      labelSingle="Modo lectura"
      v-model="component.componentProps.disabled"
    />
    <LmEditor
      class="col-12"
      v-model="component.componentProps.defaultValue"
      :label="$t('default_content')"
      @input="$emit('input', component)"
    />
    <LmCheckbox
      v-if="allowVoiceRecognitionSettings"
      class="col-12 col-md-6"
      variant="switch"
      :labelSingle="$t('voice_recognition')"
      :help="$t('voice_recognition_help')"
      v-model="component.componentProps.enableVoiceRecognition"
    />
    <div class="col-12">
      <h5>{{ $t('variables') }}</h5>
      <div
        v-for="(option, index) in component.componentProps.variablesOptions"
        :key="index"
        class="row align-items-center"
      >
        <LmTextInput
          :id="`name-${id}-${index}`"
          class="col-12 col-md-6"
          v-model="component.componentProps.variablesOptions[index].name"
          :label="$t('name')"
          :placeholder="$t('name')"
        />
        <LmTextInput
          :id="`value-${id}-${index}`"
          class="col-12 col-md-5"
          v-model="component.componentProps.variablesOptions[index].value"
          @input="$emit('input', component)"
          :label="$t('variable')"
          :placeholder="$t('variable')"
        />
        <font-awesome-icon
          :id="`trash-icon-${index}`"
          class="clickable mt-3 col-12 col-md-1"
          icon="trash"
          @click="removeOption(index)"
          v-b-tooltip.hover.top="$t('delete')"
        />
      </div>
      <LmButton
        class="col-auto px-0"
        :id="`lm-button-${id}`"
        type="button"
        :value="$t('add_option')"
        @click="addOption"
      />
    </div>
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmEditor from '@/components/form/elements/lmEditor'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import { nanoid } from 'nanoid'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      allowVoiceRecognitionSettings: process.env?.VUE_APP_ENABLE_DOCUMENTSTYPE_VOICE_RECOGNITION === 'yes'
    }
  },
  components: {
    LmButton,
    LmCheckbox,
    LmSelect,
    LmEditor,
    LmNumberInputV2
  },
  methods: {
    addOption () {
      this.component.componentProps.variablesOptions.push({ id: nanoid(5), name: '', value: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.variablesOptions.splice(optionIndex, 1)
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
